/**
 * @fileoverview Lock screen overlay that appears after inactivity or on page reload.
 * Covers the entire app until a valid PIN is entered.
 * Rendered at the layout level inside AuthProvider.
 */
"use client";

import useAuth from "@/hooks/auth/useAuth";
import { PinEntryDialog } from "./pin-entry-dialog";

/**
 * @description Full-screen lock overlay. Shows when isLocked is true.
 * Any valid PIN unlocks and switches to that user.
 * Includes logout button to fully sign out.
 */
export function PinLockScreen() {
  const { isLocked, switchUser, signOut, isAuthenticated } = useAuth();

  if (!isLocked || !isAuthenticated) return null;

  const handlePinSubmit = async (pin: string): Promise<{ error?: string }> => {
    return switchUser(pin);
  };

  const handleLogout = async () => {
    await signOut();
  };

  return (
    <PinEntryDialog
      open={true}
      onPinSubmit={handlePinSubmit}
      title="Scan or enter your PIN"
      showLogout
      onLogout={handleLogout}
    />
  );
}
